//Dependencies
import React from 'react';
import { Link } from 'react-router-dom';
import { HomeOutlined, EyeOutlined, EyeInvisibleOutlined, TeamOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';

/* MENU BAR */
const Menu02 = (props) =>
{
  const { bottom, height  } = props;
  const dispatch = useDispatch();
  const hidehotspots = useSelector(state => state.tours.hidehotspots);
  
  return(
    <footer 
      className = {` fixed bottom-0 flex justify-center items-center bg-white text-gray-800 w-screen border-t-2 border-slate-500 drop-shadow-xl z-[1000] `}
      style = {{height : height, bottom : bottom}}
    >
      <div className = ' w-[350px] flex justify-center items-center h-full '>
        <Link 
          className = "flex flex-1 justify-center items-center text-gray-900 hover:text-sky-600 cursor-pointer"
          target    = "_blank" 
          to          = {'/'}
        >
          <HomeOutlined className = " text-3xl lg:text-4xl flex "/>
        </Link>

        {hidehotspots && 
          <div
            className = "flex flex-1 justify-center items-center text-gray-900 hover:text-sky-600 cursor-pointer"
            onClick   = {() => dispatch({type: 'SET_HIDE_HOTSPOTS', hidehotspots : false})}
          >
            <EyeOutlined className = " text-3xl lg:text-4xl flex "/>
          </div>
        }

        {!hidehotspots && 
          <div
            className = "flex flex-1 justify-center items-center text-gray-900 hover:text-sky-600 cursor-pointer"
            onClick   = {() => dispatch({type: 'SET_HIDE_HOTSPOTS', hidehotspots : true})}
          >
            <EyeInvisibleOutlined className = " text-3xl lg:text-4xl flex "/>
          </div>
        }

        <div className = "flex flex-1 justify-center items-center text-gray-900 hover:text-sky-600">
          <div
            className = "flex flex-1 justify-center items-center text-gray-900 hover:text-sky-600 cursor-pointer"
            onClick   = {() => dispatch({type: 'SET_DRAWER_03', drawer03 : true})}
          >
             <i className = "fa fa-briefcase flex text-3xl lg:text-4xl flex " ></i>
          </div>
        </div>      

        <div className = "flex flex-1 justify-center items-center text-gray-900 hover:text-sky-600">
          <div
            className = "flex flex-1 justify-center items-center text-gray-900 hover:text-sky-600 cursor-pointer"
            onClick   = {() => dispatch({type: 'SET_DRAWER_04', drawer04 : true})}
          >
            <TeamOutlined className = " text-3xl lg:text-4xl flex "/>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Menu02;